<template>
    <div class="searchComponent" :class="{componentLoading: this.loading}">

        <!-- REKAPITULACE -->
        <section id="your-way" class="container-fluid text-white">
            <div class="s7_underpage-slider-sw s7_sw-sec mx-auto">
                <h1 class="text-center text-white text-uppercase font-weight-bold pb-2">{{translations.vaseCesta}}</h1>
                <div class="s7_place-ftw d-flex align-items-center flex-md-row flex-column justify-content-center">
                    <div class="s7_place-start d-flex align-items-center">
                        <i class="fas text-white fa-map-marker-alt mr-3"></i>
                        <p class="text-white font-weight-light mb-0">{{this.ddestination_from}}</p>
                    </div>
                    <div class="s7_ftw-arrows">
                        <i class="fas fa-caret-right mr-2 text-white"></i>
                        <i class="fas fa-caret-right mr-2 text-white"></i>
                        <i class="fas fa-caret-right text-white"></i>
                    </div>
                    <div class="s7_place-finish d-flex align-items-center">
                        <i class="fas text-white fa-map-marker-alt mr-3"></i>
                        <p class="text-white font-weight-light mb-0">{{this.ddestination_to}}</p>
                    </div>
                </div>
                <div class="s7_underpage-col-row mx-auto d-flex justify-content-center">
                    <div class="s7_underpage-ico d-flex align-items-center">
                        <figure class="mb-0"><img :src="images_path + '/route.png'" alt="" class="w-100"></figure>
                        <p class="s7_underpage-text font-weight-light text-white mb-0"><strong class="text-white">{{distance}}</strong> Km</p>
                    </div>
                    <div class="s7_underpage-ico d-flex align-items-center">
                        <figure class="mb-0"><img :src="images_path + '/time.png'" alt="" class="w-100"></figure>
                        <p class="s7_underpage-text font-weight-light text-white mb-0"><strong class="text-white">{{duration | duration('humanize', {d: 7, w: 4, h:60, d: 24, m: 60}) }}</strong></p>
                    </div>
                    <div class="s7_underpage-ico d-flex align-items-center">
                        <figure class="mb-0"><img :src="images_path + '/money.png'" alt="" class="w-100"></figure>
                        <p class="s7_underpage-text font-weight-light text-white mb-0">od <strong class="text-white">{{ minPrice | format_price }}</strong> {{ currency_label }}</p>
                    </div>
                </div>
                <a :href="home_url" class="btn rounded-0 w-100 font-weight-bold d-flex align-items-center justify-content-between mx-auto text-uppercase">
                    <span class="text-white">{{translations.zmenitCestu}}</span>
                    <i class="fas fa-chevron-right text-white"></i>
                </a>
            </div>
        </section>


        <!-- MAPA A SEZNAM -->
        <section id="search-map" class="container-fluid row mx-0">
            <div class="s7_car-col col-xl-6 col-12 pr-0">
                <form action="">
                    <select name="sorting_name" id="sorting_id" class="text-uppercase border-0 rounded-0 w-100" v-model="sortBy">
                        <option value="0" selected>{{translations.raditDleCenyVzestupne}}</option>
                        <option value="1">{{translations.raditDleCenySestupne}}</option>
                    </select>
                    <select name="currency_name" id="curreny_id" class="text-uppercase border-0 rounded-0 w-100" v-model="currency">
                        <option value="0" selected>{{translations.menaCZK}}</option>
                        <option value="1">{{translations.menaEUR}}</option>
                    </select>
                </form>


                <div class="s7_nabidka-aut">
                    <div class="s7_nabidka-aut-info d-flex flex-wrap" v-for="(auto, index) in cars_offers" :key="index">
                        <figure class="s7_res-car-img mb-0 position-relative mb-2" :class="{top: parseInt(auto.db_top)==1}">
                            <img :src="getFrontImage(auto)" alt="" class="img-fluid">
                        </figure>
                        <div class="s7_car-text">
                            <div class="d-flex align-items-center">
                                <h3 class="font-weight-bold mr-3 mb-0">{{auto.db_trida}}</h3>
                                <div class="s7_nabidka-aut-stars">
                                    <i class="fas fa-star" v-for="hvezda in parseInt(auto.db_hvezdy)"></i>
                                </div>
                            </div>
                            <div class="s7_nabidka-aut-typ-auto font-italic mb-1">{{auto.db_nazev}}</div>
                            <p class="s7_nabidka-aut-popis">
                                {{getPopis(auto)}}
                                <gallery :images="getRestPhotos(auto)" :index="image_index" v-if="getRestPhotos(auto).length > 0" @close="image_index = null"></gallery>
                                <button class="border-0 radius-0" @click="image_index=0" v-if="getRestPhotos(auto).length > 0"><i class="far fa-image"></i>{{translations.viceFotografii}}</button>
                            </p>
                        </div>
                        <div class="s7_reservation-buttons">
                            <div class="s7_res-button-one-way d-flex align-items-center">
                                <div class="s7_res-price w-100 font-weight-bold">
                                    <p class="s7_res-big-text">{{getPriceTowards(auto) | format_price}} <span class="s7_res-normal-text">{{currency_label}}</span></p>
                                    <p class="s7_res-small-text mb-0">{{translations.jednosmerna}}</p></div>
                                <a href="#" @click.prevent="openPopup(auto, getPriceTowards(auto), false)" class="s7_res-btn w-100 btn rounded-0 border-0 text-uppercase d-flex justify-content-between align-items-center">
                                    <span class="text-white">{{translations.rezervovat}}</span>
                                    <i class="fas fa-chevron-right text-white"></i>
                                </a>
                            </div>
                            <div class="s7_res-button-two-way d-flex align-items-center">
                                <div class="s7_res-price w-100 font-weight-bold">
                                    <p class="s7_res-big-text">{{getPriceBackwards(auto) | format_price}} <span class="s7_res-normal-text">{{currency_label}}</span></p>
                                    <p class="s7_res-small-text mb-0">{{translations.obousmerna}}</p></div>
                                <a href="#" @click.prevent="openPopup(auto, getPriceBackwards(auto), true)" class="s7_res-btn w-100 btn rounded-0 border-0 text-uppercase d-flex justify-content-between align-items-center">
                                    <span class="text-white">{{translations.rezervovat}}</span>
                                    <i class="fas fa-chevron-right text-white"></i>
                                </a>
                            </div>
                        </div>

                        <div class="s7_nabidka-aut-sluzby d-flex flex-row">
                            <div class="s7_reservation-ico text-center d-flex align-items-center" v-if="parseInt(auto.db_voda) === 1">
                                <figure class="s7_res-ico mb-0"><img :src="images_path + '/res-ico-4.png'" alt="láhev vody" class="s7_reservation-ico-img"></figure>
                                <p class="s7_reservation-ico-text text-uppercase font-weight-bold mb-0">{{translations.piti}}</p>
                            </div>
                            <div class="s7_reservation-ico text-center d-flex align-items-center" v-if="parseInt(auto.db_wifi) === 1">
                                <figure class="s7_res-ico mb-0"><img :src="images_path + '/res-ico-2.png'" alt="wifi" class="s7_reservation-ico-img"></figure>
                                <p class="s7_reservation-ico-text text-uppercase font-weight-bold mb-0">{{translations.wifi}}</p>
                            </div>

                            <div class="s7_reservation-ico text-center d-flex align-items-center" v-if="parseInt(auto.db_vyzvednuti) === 1">
                                <figure class="s7_res-ico mb-0"><img :src="images_path + '/res-ico-1.png'" alt="nonstop" class="s7_reservation-ico-img"></figure>
                                <p class="s7_reservation-ico-text text-uppercase font-weight-bold mb-0">{{translations.vyzvednuti}}</p>
                            </div>
                            <div class="s7_reservation-ico text-center d-flex align-items-center" v-if="parseInt(auto.db_klimatizace) === 1">
                                <figure class="s7_res-ico mb-0"><img :src="images_path + '/res-ico-3.png'" alt="platební karty" class="s7_reservation-ico-img"></figure>
                                <p class="s7_reservation-ico-text text-uppercase font-weight-bold mb-0">{{translations.klimatizace}}</p>
                            </div>
                            <div class="s7_reservation-ico text-center d-flex align-items-center" v-if="parseInt(auto.db_voucher) === 1">
                                <figure class="s7_res-ico mb-0"><img :src="images_path + '/res-ico-5.png'" alt="platební karty" class="s7_reservation-ico-img"></figure>
                                <p class="s7_reservation-ico-text text-uppercase font-weight-bold mb-0">{{translations.voucher}}</p>
                            </div>
                        </div>
                    </div>
                    </div>

            </div>
            <div class="s7_map-col col-xl-6 col-12 px-0">
                <div id="map" class="s7_mapitself"></div>
            </div>
        </section>

        <!-- KONTAKT -->
        <section id="res-contact" class="container-fluid d-flex justify-content-center">
            <div class="s7_res-contact-phone d-flex align-items-center">
                <figure class="mb-0"><img :src="this.images_path + '/phone.png'" alt="phone" class="s7_res-contact-ico-img w-100"></figure>
                <a href="tel:+420 777 003 328" class="s7_res-contact-ico-text font-weight-bold text-decoration-none">+420 777 003 328</a>
            </div>
            <div class="s7_res-contact-envelope d-flex align-items-center">
                <figure class="mb-0"><img :src="this.images_path + '/envelope.png'" alt="phone" class="s7_res-contact-ico-img w-100"></figure>
                <a href="mailto:info@airportpraguetransfers.cz" class="s7_res-contact-ico-text font-weight-bold text-decoration-none">info@airportpraguetransfers.cz</a>
            </div>
            <div class="s7_res-contact-map d-flex align-items-center">
                <figure class="mb-0"><img :src="this.images_path + '/map-mark.png'" alt="phone" class="s7_res-contact-ico-img w-100"></figure>
                <span class="s7_res-contact-ico-text font-weight-bold">J. Plachty 596/8, Praha 5-Anděl</span>
            </div>
        </section>

        <ReservationForms
            ref="reservationForms"
            :destination_from="destination_from"
            :destination_from_lat_lng="getRequestLatLng('from')"
            :destination_to="destination_to"
            :destination_to_lat_lng="getRequestLatLng('to')"
            :distance="distance"
            :duration="duration"
            :currency="currency"
            :selected_offer="selected_offer"
            :selected_way_option="selected_way_option"
            :precalculated_price="precalculated_price"
            :images_path="images_path"
            :api_url="api_url"
            :home_url="home_url"
            :translations="translations"
        ></ReservationForms>
    </div>
</template>

<script>
    import {Loader, LoaderOptions} from 'google-maps';
    import {Truncate} from 'lodash';
    import Axios from "axios";
    import VueAxios from 'vue-axios';
    import VueGallery from 'vue-gallery';
    import ReservationForms from "./ReservationForms";


    export default {
        name: "search-component",
        components: {
            'gallery': VueGallery, ReservationForms
        },
        data: function(){
            return {
                google: null,
                google_map: null,
                distance: 0,
                duration: 0,
                currency: 0,
                sortBy: 0,
                loading: true,
                car_offers: [],
                image_index: null,
                selected_offer: false,
                selected_way_option: false,
                precalculated_price: 0,
                resolved_from_lat_lng: null,
                resolved_to_lat_lng: null
            }
        },
        props: {
            images_path: {
                required: true,
                type: String
            },
            destination_from: {
                required: true,
                type: String
            },
            destination_to: {
                required: true,
                type: String
            },
            destination_from_lat_lng: {
                required: true,
                type: Object
            },
            destination_to_lat_lng: {
                required: true,
                type: Object
            },
            google_api_key: {
                required: true,
                type: String
            },
            api_url: {
                required: true,
                type: String
            },
            home_url: {
                required: true,
                type: String
            },
            kurz_eur: {
                required: true,
                type: Number
            },
            translations: {
                required: true,
                type: Object
            }
        },
        async mounted() {
            // start map
            try {
                const options = {libraries: ['places']};
                const loader = new Loader(this.google_api_key, options);
                const google = await loader.load();
                this.google = google;
                window.google = google;
                this.$root.$emit("googleMapsInitialized");
                this.createRoute();

            } catch (error) {
                console.error(error);
            }
        },
        methods: {
            buildMap: function () {
                const map = new google.maps.Map(document.getElementById('map'), {
                    center: {lat: 50.167741, lng: 14.398851},
                    zoom: 8,
                });
                this.google_map = map;
                return map;
            },
            createRoute: function () {
                var directionsService = new google.maps.DirectionsService();
                var directionsDisplay = new google.maps.DirectionsRenderer();
                var _this = this;

                var selectedMode = 'DRIVING';
                var request = {
                    origin: this.destination_from,
                    destination: this.destination_to,
                    travelMode: google.maps.TravelMode[selectedMode]
                };

                directionsService.route(request, function(response, status) {

                    if (status == 'OK') {

                        var map = _this.buildMap();
                        directionsDisplay.setDirections(response);
                        directionsDisplay.setMap(map);

                        console.log(response);

                        var leg = response.routes[0].legs[0];
                        _this.distance = Math.ceil(leg.distance.value / 1000);
                        _this.duration = leg.duration.value * 1000;
                        _this.resolved_from_lat_lng = {
                            lat: leg.start_location.lat(),
                            lng: leg.start_location.lng()
                        };
                        _this.resolved_to_lat_lng = {
                            lat: leg.end_location.lat(),
                            lng: leg.end_location.lng()
                        };
                        _this.fetchCarsAndPrices();

                    }else {

                    }

                    _this.loading = false;
                });
            },
            fetchCarsAndPrices: function () {
                var _this = this;
                var from_lat_lng = this.getRequestLatLng('from');
                var to_lat_lng = this.getRequestLatLng('to');

                if (!from_lat_lng || !to_lat_lng) {
                    console.error('Chybí souřadnice pro načtení nabídky vozidel.');
                    this.car_offers = [];
                    this.loading = false;
                    return;
                }

                var request = {
                    from_lat_lng: from_lat_lng,
                    to_lat_lng: to_lat_lng,
                    destination_from: this.destination_from,
                    destination_to: this.destination_to,
                    distance: this.distance,
                    duration: this.duration,
                    persons: 1,
                    currency: this.currency,
                };

                var finalurl = _this.api_url + "?action=getCarOffers";


                Axios.post(finalurl, request).then(function (response) {
                    if (response && typeof response.data === "object") {
                        _this.car_offers = Array.isArray(response.data.cars) ? response.data.cars : [];
                        if (response.data.status === 0 && response.data.message) {
                            console.error(response.data.message);
                        }
                    } else {
                        console.error("Data is not type of Object");
                        _this.car_offers = [];
                    }
                    _this.loading = false;
                }).catch(function (error) {
                    console.error(error);
                    _this.car_offers = [];
                    _this.loading = false;
                });
            },
            getPriceTowards: function(car){
                var price = 0;
                if(car.hasOwnProperty('db_cenik_cena_tam')){
                    price = car.db_cenik_cena_tam;
                }else{
                    if(car.db_jednotka == "km"){
                        price = parseInt(car.db_cena_za_jednotku) * this.distance;
                    }else if (car.db_jednotka == "h"){
                        price = parseInt(car.db_cena_za_jednotku) * Math.ceil(this.duration/1000/60/60);
                    }
                    if(this.currency == 1){
                        price = price / this.kurz_eur;
                    }
                }

                price = Math.round(price);
                return price;
            },
            getPriceBackwards: function(car){
                var price = 0;

                if(car.hasOwnProperty('db_cenik_cena_zpet')){
                    price = car.db_cenik_cena_zpet;
                }else{
                    if(car.db_jednotka == "km"){
                        price = parseInt(car.db_cena_za_jednotku) * this.distance * 2;
                    }else if (car.db_jednotka == "h"){
                        price = parseInt(car.db_cena_za_jednotku) * Math.ceil(this.duration/1000/60/60) * 2;
                    }
                    if(this.currency == 1){
                        price = price / this.kurz_eur;
                    }
                }

                price = Math.round(price);
                return price;
            },
            getPopis: function (car) {
                return _.truncate(car.db_popis, {'length': 120});
            },
            getFrontImage: function (car) {
                var obrazky = car.subobjects && car.subobjects.obrazekClass;
                if (!obrazky) {
                    return this.images_path + "/auto-reservation.png";
                }
                for(var index in obrazky){
                    let obrazek = obrazky[index];
                    if(obrazek.db_front.value == 1){
                        return this.home_url + obrazek.db_url.value;
                    }
                }
                return this.images_path + "/auto-reservation.png";
            },
            getRestPhotos: function (car) {
                var obrazky = car.subobjects && car.subobjects.obrazekClass;
                var obr_arr = [];
                if (!obrazky) {
                    return obr_arr;
                }
                for(var index in obrazky){
                    let obrazek = obrazky[index];
                    if(obrazek.db_front.value != 1){
                        var image_url = this.home_url + obrazek.db_url.value;
                        image_url = image_url.replace("default","gallery");
                        obr_arr.push(image_url);
                    }
                }

                return obr_arr;
            },
            openPopup: function (auto, price, twoway) {
                this.selected_offer = auto;
                this.selected_way_option = twoway;
                this.precalculated_price = price;

                if (this.$refs.reservationForms) {
                    this.$refs.reservationForms.open({
                        destination_from: this.destination_from,
                        destination_to: this.destination_to,
                        from_lat_lng: this.getRequestLatLng('from'),
                        to_lat_lng: this.getRequestLatLng('to'),
                        distance: this.distance,
                        duration: this.duration,
                        currency: this.currency,
                        price: price
                    });
                }

                var modal = document.getElementById('Modal-form-1');
                if (modal && window.jQuery) {
                    window.jQuery(modal).modal('show');
                }
            },
            isValidLatLng: function (point) {
                if (!point || typeof point !== 'object') {
                    return false;
                }
                if (Array.isArray(point) && point.length === 0) {
                    return false;
                }
                return point.lat != null && point.lng != null;
            },
            getRequestLatLng: function (type) {
                var fromProps = this.destination_from_lat_lng;
                var toProps = this.destination_to_lat_lng;
                var fromResolved = this.resolved_from_lat_lng;
                var toResolved = this.resolved_to_lat_lng;

                if (type === 'from') {
                    return this.isValidLatLng(fromResolved) ? fromResolved : fromProps;
                }
                return this.isValidLatLng(toResolved) ? toResolved : toProps;
            }
        },
        computed: {
            ddestination_to: function () {
                return _.truncate(this.destination_to);
            },
            ddestination_from: function () {
                return _.truncate(this.destination_from);
            },
            currency_label: function () {
                return (this.currency == 1 ? "€" : "Kč");
            },
            minPrice: function () {
                if (!Array.isArray(this.car_offers) || this.car_offers.length === 0) {
                    return 0;
                }
                var _this = this;
                return this.car_offers.reduce(function (min, car) {
                    var price = _this.getPriceTowards(car);
                    return price < min ? price : min;
                }, Infinity);
            },
            cars_offers: function () {
                var sortin = this.sortBy;
                var _this = this;
                if (Array.isArray(this.car_offers) && this.car_offers.length > 0) {
                    var res = this.car_offers.slice().sort(function (a, b) {
                        var price_a = _this.getPriceTowards(a);
                        var price_b = _this.getPriceTowards(b);

                        if(sortin == 0){
                            if(price_a < price_b){
                                return -1;
                            }else if(price_a > price_b) {
                                return 1;
                            }else{
                                return 0;
                            }
                        }else{
                            if(price_a < price_b){
                                return 1;
                            }else if(price_a > price_b) {
                                return -1;
                            }else{
                                return 0;
                            }
                        }

                    });
                    return res;
                }else{
                    return [];
                }
            }
        },
        filters: {
            format_price: function (price) {
                let val = price;
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
        },
        watch: {
            sortBy: function () {
                //this.$forceUpdate();
            }
        }
    }
</script>

<style scoped>
    .componentLoading{
        position: relative;
    }

    .componentLoading:after{
        content: "";
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        background-color: rgba(255,255,255,0.7);
        background-image: url("../../../../../images/images_frontend/loading.gif");
        position: absolute;
        background-position: 50% 20%;
        background-repeat: no-repeat;
    }
</style>